import { Link } from "@tanstack/react-router";
import { useMemo } from "react";

import { Button } from "@/components/ui/button";
import { fullLocationDisplayName } from "@/helpers/games";

import { GameStatusEnum } from "../game/types";
import GameCardsSection from "./games-section";
import type { CompanyType, LocationType } from "./types";

interface LocationItemProps {
  company: CompanyType;
  filteredLocation: LocationType | null;
  location: LocationType;
  showClosedRooms: boolean;
}

export default function LocationItem({
  company,
  filteredLocation,
  location,
  showClosedRooms,
}: LocationItemProps) {
  const hasClosedGamesOnly = useMemo(
    () => !location.games.some((game) => game.status === GameStatusEnum.OP),
    [location]
  );

  if (hasClosedGamesOnly && !showClosedRooms) {
    return null;
  }

  if (filteredLocation && filteredLocation.id !== location.id) {
    return null;
  }

  return (
    <GameCardsSection
      actionButtons={
        <Button
          asChild
          className="mt-12.5 h-14 w-47.5 shrink-0 rounded-[28px]"
          variant="cta"
        >
          <Link to={`/location/${company.slug}/${location.slug}`}>
            View location
          </Link>
        </Button>
      }
      games={location.games}
      showClosedRooms={showClosedRooms}
      title={
        <Link
          className="hover:underline"
          to={`/location/${company.slug}/${location.slug}`}
        >
          {fullLocationDisplayName(location)}
          {hasClosedGamesOnly && " - CLOSED"}
        </Link>
      }
    />
  );
}
